import { render } from "./DetailsSimple.vue?vue&type=template&id=6da25b3b"
import script from "./DetailsSimple.vue?vue&type=script&lang=js"
export * from "./DetailsSimple.vue?vue&type=script&lang=js"

import exportComponent from "/Users/saleem/Sites/unitedtours/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__